import { RugbyUnionEventStatusId } from '@collector/sportsapi-client-legacy'

export const eventStatuses: RugbyUnionEventStatusId[] = [
  RugbyUnionEventStatusId.NotStarted,
  RugbyUnionEventStatusId.FirstHalf,
  RugbyUnionEventStatusId.Halftime,
  RugbyUnionEventStatusId.SecondHalf,
  RugbyUnionEventStatusId.WaitingForExtratime,
  RugbyUnionEventStatusId.ExtratimeFirstHalf,
  RugbyUnionEventStatusId.ExtratimeHalftime,
  RugbyUnionEventStatusId.ExtratimeSecondHalf,
  RugbyUnionEventStatusId.WaitingForPenalty,
  RugbyUnionEventStatusId.Penalties,
  RugbyUnionEventStatusId.FinishedRegularTime,
  RugbyUnionEventStatusId.FinishedAfterExtratime,
  RugbyUnionEventStatusId.Interrupted,
  RugbyUnionEventStatusId.Postponed,
  RugbyUnionEventStatusId.Abandoned,
  RugbyUnionEventStatusId.Cancelled,
  RugbyUnionEventStatusId.ToFinish,
]
